import {
    Component,
    OnInit,
    SimpleChanges,
    EventEmitter,
    OnChanges,
    HostListener,
    Input,
    Output,
    Renderer2,
    ViewChild
} from '@angular/core';
import {LanguageUtils} from '../../shared/utils/src/language.utils';
import {TeamServices} from '../../shared/services/src/api/team.services';
import {LocalStorageService} from 'angular-2-local-storage';
import {CommonServices} from '../../shared/services/src/api';
import {StorageUtils} from '../../shared/utils';
import * as _ from 'lodash';

@Component({
    selector: 'page-title-container',
    templateUrl: './page-title.component.html',
    styleUrls : [ './page-title.component.scss' ]
})

export class PageTitleComponent implements OnInit, OnChanges {
    @ViewChild('selectedTeamBtn') selectedTeamBtn;
    @ViewChild('myTeamTitle') myTeamTitle;
    @ViewChild('otherTeamTitle') otherTeamTitle;
    @Input() public pageTitleConfig: any;
    @Input() public goToBack: false;
    @Input() public helpLink: false;
    @Output() backToList: EventEmitter<any> = new EventEmitter<any>();

    userLang = 'en';
    @Input() public teamUseYN;
    selectedTeam = {
        type: 'TT004',
        no: '',
        name : 'MK.00013',
        teamNoUseYn : 'N'
    };

    teamData = {
        AllTeam : {
            default : {
                dispNm : 'MK.00013',
                teamNo : ''
            }
        },
        MyTeam : {
            default : {
                dispNm : 'MK.01135',
                teamNo : ''
            },
            list : [],
            count_bak : 0,
            count : 0
        },
        OtherTeam : {
            default : {
                dispNm : 'MK.01233',
                teamNo : ''
            },
            list : [],
            count_bak : 0,
            count : 0
        },
        UNASSIGNED : {
            default : {
                dispNm : 'MK.01090',
                teamNo : ''
            }
        }
    };

    public teamSearchValue = '';

    @HostListener('document:click', ['$event']) clickedOutside($event) {
        const $target = $($($event)[0].target);
        if (!$target.closest('nav.team').length) {
            $('nav.team > button').removeClass('on');
            this.teamSearchValue = '';
        }
    }

    constructor(public teamServices: TeamServices,
                private localStorageService: LocalStorageService,
                private _commonServices: CommonServices,
                private renderer: Renderer2) {
        // LanguageUtils.setLanguage();
    }

    ngOnInit(): void {
        // this.teamUseYN = global['teamUseYN'];
        /*this.teamUseYN = this.teamServices.getTeamUseBool();
        this.teamData = global['teamData'];
        const teamStr = StorageUtils.getItem('alertNow.team');
        const team = JSON.parse(teamStr);

        if (team !== null && team.no !== '') {
            let _data = _.find(this.teamData.MyTeam.list, {'teamNo': team.no});
            if (!_data) {
                _data = _.find(this.teamData.OtherTeam.list, {'teamNo': team.no});
            }
            this.teamChange(_data, team.type, team.teamNoUseYn);
        }*/
    }

    ngOnChanges(changes: SimpleChanges) {
        // team menu 예외 처리
        const pageTitle = window.location.pathname;
        if (pageTitle.startsWith('/profile') || pageTitle.startsWith('/notice')) {
            this.teamUseYN = false;
            return;
        }

        this.teamUseYN = this.teamServices.getTeamUseBool();
        this.teamData = global['teamData'];
        const teamStr = StorageUtils.getItem('alertNow.team');
        const team = JSON.parse(teamStr);

        if (team !== null && team.no !== '') {
            let _data = _.find(this.teamData.MyTeam.list, {'teamNo': team.no});
            if (!_data) {
                _data = _.find(this.teamData.OtherTeam.list, {'teamNo': team.no});
            }
            this.teamChange(_data, team.type, team.teamNoUseYn);
        }
    }

    close() {
      this.backToList.emit();
    }

    viewManualForThisMenu () {
        this.userLang = LanguageUtils.getLangCode();

        const title = this.pageTitleConfig.pageTitle;
        const pageTitle = window.location.pathname;

        if (pageTitle.startsWith('/incident')) {
            window.open(`${global['urlInfo'].portalUrl}docs/alertnow/${this.userLang}/user-guide-alertnow-${this.userLang}.html#incident`);
        } else if (pageTitle.startsWith('/service')) {
            window.open(`${global['urlInfo'].portalUrl}docs/alertnow/${this.userLang}/user-guide-alertnow-${this.userLang}.html#service`);
        } else if (pageTitle.startsWith('/escalation')) {
            window.open(`${global['urlInfo'].portalUrl}docs/alertnow/${this.userLang}/user-guide-alertnow-${this.userLang}.html#escalations`);
        } else if (pageTitle.startsWith('/integration')) {
            window.open(`${global['urlInfo'].portalUrl}docs/alertnow/${this.userLang}/user-guide-alertnow-${this.userLang}.html#integration`);
        } else if (pageTitle.startsWith('/extension')) {
            window.open(`${global['urlInfo'].portalUrl}docs/alertnow/${this.userLang}/user-guide-alertnow-${this.userLang}.html#extensions`);
        } else if (pageTitle.startsWith('/change-history')) {
            window.open(`${global['urlInfo'].portalUrl}docs/alertnow/${this.userLang}/user-guide-alertnow-${this.userLang}.html#change-history`);
        } else if (pageTitle.startsWith('/noti-history')) {
            window.open(`${global['urlInfo'].portalUrl}docs/alertnow/${this.userLang}/user-guide-alertnow-${this.userLang}.html#noti-history`);
        } else if (pageTitle.startsWith('/personalsetting')) {
            window.open(`${global['urlInfo'].portalUrl}docs/alertnow/${this.userLang}/user-guide-alertnow-${this.userLang}.html#personal-settings`);
        } else if (pageTitle.startsWith('/schedule')) {
            window.open(`${global['urlInfo'].portalUrl}docs/alertnow/${this.userLang}/user-guide-alertnow-${this.userLang}.html#schedule`);
        } else if (pageTitle.startsWith('/analytics/system') || pageTitle.startsWith('/analytics/sysview')) {
            window.open(`${global['urlInfo'].portalUrl}docs/alertnow/${this.userLang}/user-guide-alertnow-${this.userLang}.html#system-report`);
        } else if (pageTitle.startsWith('/analytics/incident') || pageTitle.startsWith('/analytics/inctview')) {
            window.open(`${global['urlInfo'].portalUrl}docs/alertnow/${this.userLang}/user-guide-alertnow-${this.userLang}.html#incident-report`);
        } else if (pageTitle.startsWith('/analytics/notification') || pageTitle.startsWith('/analytics/notiview')) {
            window.open(`${global['urlInfo'].portalUrl}docs/alertnow/${this.userLang}/user-guide-alertnow-${this.userLang}.html#notification-report`);
        } else if (pageTitle.startsWith('/team')) {
            window.open(`${global['urlInfo'].portalUrl}docs/alertnow/${this.userLang}/user-guide-alertnow-${this.userLang}.html#team`);
        } else if (pageTitle.startsWith('/user')) {
            window.open(`${global['urlInfo'].portalUrl}docs/alertnow/${this.userLang}/user-guide-alertnow-${this.userLang}.html#user`);
        } else {
            window.open(`${global['urlInfo'].portalUrl}docs/alertnow/${this.userLang}/user-guide-alertnow-${this.userLang}.html`);
        }
    }

    tabClick($event) {
        const targets = $event.target.parentElement;
        if (targets.classList.contains('myTeam')) {
            this.otherTeamTitle.nativeElement.classList.remove('on');
        } else {
            this.myTeamTitle.nativeElement.classList.remove('on');
        }

        if (targets.classList.contains('on')) {
            targets.classList.remove('on');
        } else {
            targets.classList.add('on');
        }
    }

    getTeamList() {
        let queryString = '';
        queryString += 'page=1';
        queryString += '&rows=10000';
        queryString += '&oidx=dispNm:asc';

        const myTeamQueryString = queryString + '&type=TT001';
        this._commonServices.getTeamList(myTeamQueryString).then(result => {
            if (result.status === 200) {
                this.teamData.MyTeam.list = result.json().data;
                this.teamData.MyTeam.list.forEach(data => {
                    data.dispNm = _.unescape(data.dispNm);
                });
                this.teamData.MyTeam.default.teamNo = '';
                this.teamData.MyTeam.count = this.teamData.MyTeam.count_bak = this.teamData.MyTeam.list.length;
                global['teamData'].MyTeam = this.teamData.MyTeam;
            }
        });

        const otherTeamQueryString = queryString + '&type=TT002';
        this._commonServices.getTeamList(otherTeamQueryString).then(result => {
            if (result.status === 200) {
                this.teamData.OtherTeam.list = result.json().data;
                this.teamData.OtherTeam.list.forEach(data => {
                    data.dispNm = _.unescape(data.dispNm);
                });
                this.teamData.OtherTeam.default.teamNo = '';
                this.teamData.OtherTeam.count = this.teamData.OtherTeam.count_bak = this.teamData.OtherTeam.list.length;
                global['teamData'].OtherTeam = this.teamData.OtherTeam;
            }
        });
    }

    teamChange(teamData, searchType, teamNoUseYn) {
        this.selectedTeam = {
            type: searchType,
            name : teamData.dispNm.replace('<mark>', '').replace('</mark>', ''),
            no: teamData.teamNo,
            teamNoUseYn: teamNoUseYn
        };

        const _data = {
            'type' : this.selectedTeam.type,
            'no' : this.selectedTeam.no,
            'teamNoUseYn' : this.selectedTeam.teamNoUseYn
        };

        StorageUtils.setItem('alertNow.team', JSON.stringify(_data));
        this.teamServices.setTeamNo(this.selectedTeam);
        if (this.selectedTeamBtn) {
            this.renderer.removeClass(this.selectedTeamBtn.nativeElement , 'on');
        }
        this.teamSearchValue = '';
    }

    expand(event) {
        const target = event.target;
        const $target = $(target);

        if (this.selectedTeamBtn.nativeElement.classList.contains('on')) {
            this.renderer.removeClass(this.selectedTeamBtn.nativeElement , 'on');
        } else {
            this.getTeamList();
            this.renderer.addClass(this.selectedTeamBtn.nativeElement , 'on');
        }
    }

    teamSearch(event) {
        const keyword = event.target.value.toString();

        let myTeamCnt = 0;
        let otherTeamCnt = 0;
        this.teamData.MyTeam.list.forEach(row => {
            const orgDispNm = row.dispNm.replace('<mark>', '').replace('</mark>', '');
            const startIdx = orgDispNm.toUpperCase().indexOf(keyword.toUpperCase());
            const length = keyword.length;
            const markWord = orgDispNm.substr(startIdx, length);

            if (orgDispNm.search(new RegExp(keyword, 'i')) !== -1) {
                row.matched = true;
                myTeamCnt++;
                row.dispNm = orgDispNm.replace(markWord, '<mark>' + markWord + '</mark>');
            } else {
                row.matched = false;
            }
        });

        this.teamData.OtherTeam.list.forEach(row => {
            const orgDispNm = row.dispNm.replace('<mark>', '').replace('</mark>', '');
            const startIdx = orgDispNm.toUpperCase().indexOf(keyword.toUpperCase());
            const length = keyword.length;
            const markWord = orgDispNm.substr(startIdx, length);
            if (orgDispNm.search(new RegExp(keyword, 'i')) !== -1) {
                row.matched = true;
                otherTeamCnt++;
                row.dispNm = orgDispNm.replace(markWord, '<mark>' + markWord + '</mark>');
            } else {
                row.matched = false;
            }
        });
        global['teamData'].MyTeam.count = this.teamData.MyTeam.count = myTeamCnt;
        global['teamData'].OtherTeam.count = this.teamData.OtherTeam.count = otherTeamCnt;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/page-title/page-title.component.ts